<template lang="pug">
div
	page-header(:title='title', :url='url', :titleNew='titleNew')
	.row
		.col-md-4
			input-form-text(textInput='Título', :required='true', v-model='filtro.titulo', :value='filtro.titulo' :layout="false")
		.col-md-7
		.col-md-1
			br
			button.btn.btn-primary(@click.prevent='getLimparFiltro') Limpar
	br
	vue-element-loading(:active='isActive' spinner='bar-fade-scale' color='#428BCA')
	grid(
		ref="grid"
		:url='urlDataSource'
		:columns='columns'
		:GridHeight="400"
		:GridPageable="true"
		:DSpageSize="8"
		:DSserverPaging="true"
		:DSschema="true"
		:DSschemaData="'data'"
		:DSschemaTotal="'total'"
		:DSschemaParse="parse"
		:GridPageablePageSizes="[1, 10, 20, 100]"
		:DSfilter="filter"
		:DSserverFiltering="true"
	)
</template>

<script>
import VueElementLoading from 'vue-element-loading'
import PageHeader from '@/components/PageHeader'
import Grid from '@/components/Grid'

import GridTemplate from '@/mixins/GridTemplate.Open'
import Permission from '@/mixins/Permission'

import InputFormText from '@/components/form/InputForm'

import { confirme, erro, sucesso } from '@/components/Message'
import req from '@/components/request'

export default {
	mixins: [GridTemplate, Permission],
	components: {
		VueElementLoading,
		PageHeader,
		Grid,
		InputFormText,
	},
	computed: {
		filter() {
			return {
				logic: 'and',
				filters: [
					{
						field: 'titulo',
						operator: 'contains',
						value: this.filtro.titulo
					}
				]
			}
		},
		urlDataSource() {
			return `${this.$url}/v1/fornecedores?offset=8`
		}
	},
	watch: {
		'filtro.titulo' () {
			this.setFiltro()
		}
	},
	data() {
		return {
			title: 'Fornecedores',
			titleNew: '',
			url: '/servicos/fornecedores/',
			columns: [{
				field: 'id',
				title: 'Id',
				width: 40
			}, {
				field: 'titulo',
				title: 'Título',
				width: 200
			}, {
				field: 'active_name',
				title: 'Ativo',
				width: 50
			}],
			filtro: {
				titulo: null,
			},
			isActive: false,
		}
	},
	methods: {
		parse(d) {
			d.data.map(i => {
				return i
			})
			return d
		},
		verifPermissao() {
			this.titleNew = this.ACTION.c ? 'Novo' : ''
			if (this.ACTION.e || this.ACTION.d) {
				this.columns.push({
					field: 'ativo',
					title: 'Ações',
					width: 105,
					template: this.commandTemplate
				})
			}
		},
		setFiltro() {
			let filtro = {
				title: this.filtro.title,
			}
			localStorage.setItem('_filtroFornecedor', JSON.stringify(filtro))
		},
		getLimparFiltro() {
			let filtro = {
				titulo: null,
			}
			localStorage.setItem('_filtroFornecedor', JSON.stringify(filtro))
			this.filtro = filtro
		},
		async buttonClickApagar(item) {
			const result = await confirme(item.title,'Tem certeza que deseja remover esse registro? pois a exclusão é irreversível e não é possível voltar os dados')
			if(result.isConfirmed) {
				this.isActive = true
				await req(`/v1/fornecedores/${item.id}`, 'delete').catch(response => {
					'error: ' + response
					erro()
				})
				sucesso('Atualizado...')
				this.$refs.grid.$refs.datasource1.kendoDataSource.read()
			}
			this.isActive = false
		}
	},
	created() {
		this.verifPermissao()
		let filtro = localStorage.getItem('_filtroTitulo')
			? JSON.parse(localStorage.getItem('_filtroTitulo'))
			: null
		if (filtro) {
			this.filtro = filtro
		}
	}
}
</script>

<style lang="stylus">
</style>
